<template>
  <v-container>
    <language-switcher floating />
    <validation-observer v-slot="{ valid }">
      <v-form @submit.prevent="login">
        <div class="login">
          <h1>{{ $t("new-password") }}</h1>
          <p>{{ $t("new-password-text") }}</p>
          <v-row no-gutters>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                :name="$t('password').toLowerCase()"
                :rules="{ required: true, min: 6 }"
              >
                <v-text-field
                  v-model="request.password"
                  outlined
                  :label="$t('password')"
                  :error-messages="errors"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                >
                  <template #[`prepend-inner`]>
                    <v-img
                      max-width="22px"
                      :src="require(`@/assets/password-gray.svg`)"
                    />
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                :name="$t('password-confirmation').toLowerCase()"
                :rules="{ required: true, min: 6 }"
              >
                <v-text-field
                  v-model="request.password_confirmation"
                  outlined
                  :label="$t('password-confirmation')"
                  :error-messages="errors"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                >
                  <template #[`prepend-inner`]>
                    <v-img
                      max-width="22px"
                      :src="require(`@/assets/password-gray.svg`)"
                    />
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="text-right mt-10 pt-10">
              <v-btn
                color="primary"
                type="submit"
                :disabled="!valid || request.password != request.password_confirmation"
                elevation="0"
                block
              >
                {{ $t("submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </validation-observer>
  </v-container>
</template>

<script>
import LanguageSwitcher from "../components/LanguageSwitcher";

export default {
  mixins: [],
  components: {
    LanguageSwitcher,
  },
  data: () => ({
    showPassword: false,
    request: {
      code: "",
      password: "",
      password_confirmation: "",
    },
  }),
  computed: {},
  created: function () {
    this.request.code = this.$route.params.id;
  },
  methods: {
    async login() {
      try {
        await this.$api.put("/auth/recovery", this.request);

        await this.$store.dispatch(
          "notificator/success",
          this.$t("your-password-has-been-changed")
        );
        await this.$router.push({ name: "dashboard" });
      } catch (error) {
        await this.$store.dispatch("notificator/errorResponse", error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  align-items: center;

  .login {
    width: 342px;

    h1 {
      color: #1d3557;
      font-weight: 900;
      font-size: 36px;
      line-height: 120%;
    }

    .v-btn {
      font-weight: 500;
      font-size: 18px;
    }
  }
}
</style>
